import { Component, Input } from '@angular/core';

/**
 * sm 26px (burbujas del chat) · md 36px (header del panel) · lg 96px (home) ·
 * xl 62px circular con halo rojo (burbuja flotante, §7.2).
 */
export type JuanaAvatarSize = 'sm' | 'md' | 'lg' | 'xl';

/**
 * PLAN-Pitts-Juana-General-FRONT.md §4.4 — avatar de Juana, antes duplicado
 * como reglas `.mascot` / `.mascot-sm` dentro de agent-panel.component.scss.
 * Si falta /assets/juana/juana-avatar.png cae al gradiente rojo, así nunca se
 * ve una imagen rota.
 */
@Component({
  selector: 'app-juana-avatar',
  standalone: false,
  templateUrl: './juana-avatar.component.html',
  styleUrl: './juana-avatar.component.scss',
})
export class JuanaAvatarComponent {
  @Input() size: JuanaAvatarSize = 'md';
  /** Punto verde de "en línea" (solo lo usa el header del panel). */
  @Input() statusDot = false;
}
